module.exports = __webpack_public_path__ + "static/media/10.3c723a72.jpg";